(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.coupon.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.coupon.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const Paper = svs.ui.ReactPaper;
const WagerSkeletonCoupon = _ref => {
  let children = _ref.children,
    className = _ref.className;
  return React.createElement(Paper, {
    branding: "sport",
    className: clx('pg_my_bets_wager_fallback__grid__coupon"', className)
  }, children);
};
setGlobal('svs.components.tipsen.modularBase.WagerSkeletonCoupon', WagerSkeletonCoupon);

 })(window);